document.addEventListener("DOMContentLoaded", function () {
  function isMobile() {
    return window.innerWidth <= 750;
  }

  const detailsElement = document.querySelector(".opniew__pdp__reviews");

  if (detailsElement) {
    detailsElement.querySelector("summary").addEventListener("click", function (event) {
        if (!isMobile()) {
          event.preventDefault();
        }
    },false);

    if (!isMobile()) {
      detailsElement.setAttribute("open", true);
    }

    window.addEventListener("resize", function () {
      if (!isMobile()) {
        detailsElement.setAttribute("open", true);
      }
    });
  }
});